import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as giftboxActionCreators from '../../Giftbox/redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* registerAwardEntry({params}) {
  try {
    const response = yield call(() =>
      API.post(ROUTES.API_REGISTER_AWARD_ENTRY, params)
    );
    yield put(actionCreators.registerAwardEntrySuccess(response.data.data));
    yield put(giftboxActionCreators.getPoint());
  } catch (error) {
    error = error.response
    if (error.status === 422) {
      yield put(actionCreators.registerAwardEntryFailed(error.data.errors));
    }
  }
}

function* register() {
  yield takeLatest(actionTypes.REGISTER_AWARD, registerAwardEntry);
}

export default register;
